import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import {LANDING_PAGE_URL} from "../../../../../Globals.ts";
import {handleLinkClick} from "../../../../../Utils/misc/openLink.ts";
import {useAppStore} from "../../../../../GlobalStore/GlobalStore.ts";

interface ManageSubscriptionButtonProps {}

const ManageSubscriptionButton: React.FC<ManageSubscriptionButtonProps> = () => {
  const environmentObj = useAppStore((state: any) => state.environmentObj);
  const { environment, vscode } = environmentObj;
  const url = `${LANDING_PAGE_URL}/manage-account`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex mx-auto items-center px-4 py-2 max-w-56 bg-cyan-700 dark:bg-cyan-800 text-white rounded-md hover:bg-cyan-600 dark:hover:bg-cyan-700 transition-colors duration-200"
      onClick={(e) => handleLinkClick(e, environment, vscode, url)}
    >
      Manage Subscription
      <FontAwesomeIcon icon={faExternalLinkAlt} className="ml-2.5 h-3.5 w-3.5" />
    </a>
  );
};

export default ManageSubscriptionButton;